module.exports = __webpack_public_path__ + "static/media/logo-circle.b7865fd0.png";